import { mdiFire, mdiMarkerCheck } from "@mdi/js";
import Icon from "@mdi/react";
import { Space } from "antd";
import React from "react";

export const LEGEND_ICONS = {
  "guaranteed": mdiMarkerCheck,
  "almost-guaranteed": mdiFire,
}

type LegendId = keyof typeof LEGEND_ICONS;

const legends = [
  { id: "guaranteed", label: "Guaranteed Departure", color: "#999999"},
  // { id: "almost-guaranteed", label: "Selling Fast", color: "#999999"}
] as const satisfies ReadonlyArray<{ id: LegendId; label: string; color: string }>;

const Legends = () => {
  return (
    <div className="legends-v2">
      <Space size={17}>
        {
          legends.map(legend => <span key={legend.id} className={`legend guaranteed-indicator-icon ${legend.id}`}> <Icon path={LEGEND_ICONS[legend.id]} size="16px" /> {legend.label} </span>)
        }
      </Space>
    </div>
  );
};

export default Legends;